@if(showUOM){
  <div>
    <up-text-field [fieldLabel]="fieldLabel" [errorState]="errorState" [fieldMessage]="errorMessageText">
      <input id="unitInput" type="text"
        [ngClass]="{'text-align-right': alignmentRight, 'text-align-left': !alignmentRight}" [formControl]="textFieldForm"
        [placeholder]="placeholder" [maxLength]="fieldLength" (blur)="updateComponent()"
        (keydown)="preventNonNumeric($event)" (input)="formatValue()" autocomplete="off"/>
      <label for="unitInput" style="margin-top: 9px;">{{ unitsOfMeasure }}</label>&nbsp;&nbsp; </up-text-field>
  </div> }
@if(!showUOM){
  <div>
    <up-text-field [ngClass]="{'longWidth' :fullWidth}" [fieldLabel]="fieldLabel" [errorState]="errorState" [fieldMessage]="errorMessageText">
      <input type="text" [ngClass]="{'text-align-right' :alignmentRight, 'text-align-left' : !alignmentRight}"
        [formControl]="textFieldForm" [placeholder]="placeholder" [maxLength]="fieldLength" (blur)="updateComponent()"
        (keydown)="preventNonNumeric($event)" (input)="formatValue()" [readonly]="isReadOnly" autocomplete="off"/>
    </up-text-field>
  </div> 
}
